import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import themeVariables from '~/shared/themeVariables';
import { fileHelper } from '~/utils';

const CategoryBreadcrumb = ({ t, collectionName, pageText, page }) => {
  return (
    <ol className="breadcrumb">
      <li
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
        name={t('home_page')}
      >
        <I18nLink href="/">
          <a className="previous-link" itemProp="item" href="/">
            <span itemProp="name">{t('home_page')}</span>
          </a>
        </I18nLink>
        <meta itemProp="position" content="1" />
      </li>
      <span className="separator">{'>'}</span>
      {collectionName ? (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={t('all_collection')}
        >
          <I18nLink href="/collections">
            <a className="previous-link" href="/collections" itemProp="item">
              <span itemProp="name">{t('all_collection')}</span>
            </a>
          </I18nLink>
          <meta itemProp="position" content="2" />
        </li>
      ) : (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={t('all_collection')}
        >
          <a itemProp="item" className="active-link">
            <span itemProp="name"> {t('all_collection')}</span>
          </a>
          <meta itemProp="position" content="2" />
        </li>
      )}
      {collectionName && <span className="separator">{'>'}</span>}

      {collectionName && (!page || page < 2) && (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={fileHelper.capitalizeString(collectionName)}
        >
          <a itemProp="item" className="active-link">
            <span itemProp="name">
              {fileHelper.capitalizeString(collectionName)}
            </span>
          </a>
          <meta itemProp="position" content="3" />
        </li>
      )}
      {collectionName && page >= 2 && (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          name={fileHelper.capitalizeString(collectionName) + ' ' + pageText}
        >
          <a itemProp="item" className="active-link">
            <span itemProp="name">
              {fileHelper.capitalizeString(collectionName) + ' ' + pageText}
            </span>
          </a>
          <meta itemProp="position" content="3" />
        </li>
      )}
      <style jsx>
        {`
          .breadcrumb {
            display: flex;
            flex-directoin: row;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            margin: 0;
            padding: 0;
            white-space: nowrap;
            background-color: transparent;
          }

          // .previous-link {
          //   color: ${themeVariables.colors.primary};
          // }
          .previous-link:hover {
            text-decoration: underline !important;
          }

          .active-link {
            color: #000000 !important;
          }

          .active-link:hover {
            opacity: 1;
          }

          .separator {
            margin: 0 4px;
          }

          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .breadcrumb {
              font-size: 16px;
              flex-wrap: wrap;
            }
          }
        `}
      </style>
    </ol>
  );
};

export default withI18next(['page-collections'])(CategoryBreadcrumb);
